import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { getApplicationSize, getApplicationSizeMediaQueryLists, } from '../../../utilities/browser';
export const useViewportSize = ({ ignoreChange = false, renderingMode = 'csr', }) => {
    const theme = useTheme();
    const [viewportBreakpoint, setViewportBreakpoint] = useState(renderingMode === 'ssr' ? 'small' : getApplicationSize({ theme }));
    useEffect(() => {
        if (ignoreChange) {
            return () => { };
        }
        const checkMatch = () => {
            setViewportBreakpoint(getApplicationSize({ theme }));
        };
        getApplicationSizeMediaQueryLists({ theme }).forEach(({ mediaQueryList }) => {
            mediaQueryList.addEventListener('change', checkMatch);
        });
        checkMatch();
        return () => {
            getApplicationSizeMediaQueryLists({ theme }).forEach(({ mediaQueryList }) => {
                mediaQueryList.removeEventListener('change', checkMatch);
            });
        };
    }, [theme, ignoreChange]);
    return viewportBreakpoint;
};
